import { render, staticRenderFns } from "./SecurityForSupport.vue?vue&type=template&id=187a7416"
import script from "./SecurityForSupport.vue?vue&type=script&lang=js"
export * from "./SecurityForSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports